<div [formGroup]="formPrsDetails">
  <h2>Prs Details</h2>
  <div class="prs-details__container prs-details__container--with-wizard-buttons">
    <p class="prs-details__info">Registered Address</p>
    <button class="prs-details__button--copy" mat-raised-button (click)="copyGeneralToPrs()">Copy from General Details</button>

    <div class="prs-details__grid">
      <div>
        <mat-form-field>
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 2</mat-label>
          <input matInput formControlName="addressLine2" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 3</mat-label>
          <input matInput formControlName="addressLine3" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 4</mat-label>
          <input matInput formControlName="addressLine4" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Postcode</mat-label>
          <input matInput formControlName="postCode" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Select county</mat-label>
          <mat-select title="Standard select" formControlName="county">
            <mat-option>--</mat-option>
            @for (county of counties; track county) {
              <mat-option [value]="county.value"> {{ county.value }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Select country</mat-label>
          <mat-select (selectionChange)="countryChanged($event.value)" title="Standard select" formControlName="country">
            <mat-option>--</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.name"> {{ country.name }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>
    </div>

    @if (showEuQuestions) {
      <div>
        <p class="prs-details__info">
          Must you register with, or get approval from, the PRS regulatory authority in your country?<br />
          If the answer is "yes", please provide details of the content of your registration, or authorisation, or approval (for example, your
          registration authorisation number).
        </p>

        <mat-form-field class="prs-details__textarea">
          <textarea matInput formControlName="q1" rows="4"></textarea>
          <mat-error>Required</mat-error>
        </mat-form-field>

        <p class="prs-details__info">Please provide the names and other details of the regulatory authorities for PRS in your country.</p>

        <mat-form-field class="prs-details__textarea">
          <textarea matInput formControlName="q2" rows="4"></textarea>
          <mat-error>Required</mat-error>
        </mat-form-field>

        <p class="prs-details__info">
          Have you or your company ever <strong>not</strong> complied with the PRS regulations in your country?<br />
          If the answer is "yes" please provide full details.
        </p>

        <mat-form-field class="prs-details__textarea">
          <textarea matInput formControlName="q3" rows="4"></textarea>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>
    }
  </div>
</div>
